@if (!isAuthenticated) {
<app-portal-navbar></app-portal-navbar>
}

<ion-content [fullscreen]="!isAuthenticated" [scrollEvents]="true">

  <!-- HERO -->
  <div class="hero" [class.hero--public]="!isAuthenticated" [class.hero--shell]="isAuthenticated">
    <div class="hero-grid-overlay"></div>
    <p class="eyebrow">{{ 'pricing.heroEyebrow' | translate }}</p>
    <h1>{{ 'pricing.heroTitleLine1' | translate }}<br><span class="gradient-text">{{ 'pricing.heroTitleLine2' | translate }}</span></h1>
    <p class="hero-sub">{{ 'pricing.heroSub' | translate }}</p>
    <p class="hero-note">{{ 'pricing.heroNote' | translate }}</p>
  </div>

  <!-- PRICING CARDS -->
  <div class="products-wrapper">
    @for (c of cards; track c.name) {
    <div class="product-card" [class.product-card--included]="c.included" [class.product-card--wide]="c.wide">
      <div class="card-header">
        <div class="card-icon">
          @if (c.iconSrc) {
          <img [src]="c.iconSrc" [alt]="c.name" class="card-icon__mark" />
          } @else {
          <ion-icon [name]="c.icon"></ion-icon>
          }
        </div>
        <div class="card-meta">
          <span class="card-tag">{{ c.tagKey | translate }}</span>
          <h2>{{ c.name }}</h2>
        </div>
      </div>

      <!-- One price line for every card, whatever its pricing model, so the figures
           line up across the row. The variant breakdown hangs below it. -->
      <div class="price-row">
        @if (c.included) {
        <span class="price-included">{{ 'pricing.included' | translate }}</span>
        } @else if (c.externalUrl) {
        <span class="price-external">{{ 'pricing.screendeck.externalPrice' | translate }}</span>
        } @else {
        @if (c.priceFrom) {
        <span class="price-from">{{ 'pricing.priceFrom' | translate }}</span>
        }
        <span class="price-value">CHF {{ c.price }}</span>
        }
        @if (c.unitKey) {
        <span class="price-unit">{{ c.unitKey | translate }}</span>
        }
      </div>
      @if (c.noteKey) {
      <p class="price-note">{{ c.noteKey | translate }}</p>
      }

      @if (c.variants) {
      <div class="price-variants">
        @for (v of c.variants; track v.labelKey) {
        <div class="price-variant">
          <div class="price-variant__head">
            <span class="price-variant__label">
              <ion-icon [name]="v.icon"></ion-icon>
              {{ v.labelKey | translate }}
            </span>
            <span class="price-variant__price">
              CHF {{ v.price }}
              <span class="price-variant__unit">{{ v.unitKey | translate }}</span>
            </span>
          </div>
          @if (v.includedKey) {
          <p class="price-variant__included">{{ v.includedKey | translate }}</p>
          }
          <p class="price-variant__note">{{ v.noteKey | translate }}</p>
        </div>
        }
      </div>
      }

      <div class="highlight-pills">
        @for (p of c.highlightKeys; track p) {
        <span class="pill">{{ p | translate }}</span>
        }
      </div>

      <div class="card-footer">
        @if (c.externalUrl) {
        <ion-button shape="round" class="btn-pricing" [href]="c.externalUrl" target="_blank" rel="noopener">
          {{ c.ctaKey | translate }}
          <ion-icon name="open-outline" slot="end"></ion-icon>
        </ion-button>
        } @else {
        <ion-button shape="round" class="btn-pricing" [routerLink]="c.route">
          {{ c.ctaKey | translate }}
          <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
        </ion-button>
        }
      </div>
    </div>
    }
  </div>

  <app-portal-footer></app-portal-footer>

</ion-content>
